import { Map, List } from 'immutable';

import { ActionTypes } from '../constants/AppConstants';
import BaseStore from './BaseStore';


class KeyGoTapsStore extends BaseStore {

    getInitialState () {
        const taps = new List();
        return new Map({ taps });
    }

    hasTaps () {
        return !this.state.get('taps').isEmpty();
    }

    handleTapsLoaded ({ taps }) {
        this.setState(this.state.set('taps', taps));
    }

    byDay () {
        return this.get('taps').groupBy((transaction) => transaction.dateTime.format('YYYY-MM-DD'));
    }

    getActionHandlers () {
        return {
            [ ActionTypes.KEYGO_TAPS_LOADED ]: this.handleTapsLoaded,
            [ ActionTypes.LOGGED_OUT ]: this.resetState
        };
    }

}

export default new KeyGoTapsStore();
